import { Notification } from 'models';
import { ACTIONS_TYPES, initialState } from '../helper';
import {
  identifyActionType,
  resolveCreateAction,
  resolveDeleteAction,
  resolveGetAction,
  resolveUpdateAction,
} from './helper';

const uniqueArray = (array) => Array.from(new Set(array));

export default (state = initialState, { type, payload, successMessage }) => {
  const actionType = identifyActionType(type);

  if (actionType === 'update') {
    return resolveUpdateAction({ state, type, successMessage });
  }

  if (actionType === 'delete') {
    return resolveDeleteAction({ state, type, successMessage });
  }

  if (actionType === 'get' || actionType === 'get-all') {
    return resolveGetAction({ state, type, payload });
  }

  if (actionType === 'create') {
    return resolveCreateAction({ state, type, successMessage });
  }

  switch (type) {
  case ACTIONS_TYPES.COMMON.PENDING_ACTION: {
    const { pendingActions = [] } = state;
    const { action = '' } = payload;

    pendingActions.push(action);

    return {
      ...state,
      pendingActions: uniqueArray(pendingActions),
    };
  }

  case ACTIONS_TYPES.COMMON.REMOVE_PENDING_ACTION: {
    return {
      ...state,
      pendingActions: [],
    };
  }

  case ACTIONS_TYPES.KUBERNETES.VERSION.GET_ALL:
  case ACTIONS_TYPES.KUBERNETES.VERSION.GET_DEFAULT:
  case ACTIONS_TYPES.KUBERNETES.VERSION.GET_COMPATIBILITIES: {
    const { pendingActions = [] } = state;
    const actionIndex = pendingActions.indexOf(type);

    if (actionIndex !== -1) {
      pendingActions.splice(actionIndex, 1);
    }

    return {
      ...state,
      version: {
        ...state.version,
        ...payload,
      },
      pendingActions,
    };
  }

  case ACTIONS_TYPES.COMMON.BUFFER_CLONE_DATA: {
    return {
      ...state,
      [ACTIONS_TYPES.COMMON.BUFFER_CLONE_DATA]: payload,
    };
  }

  case ACTIONS_TYPES.COMMON.NOTIFICATION_SHOW: {
    const { notifications = [] } = state;
    return {
      ...state,
      notifications: [
        ...notifications,
        Notification({
          action: type,
          ...payload,
        }),
      ],
    };
  }

  case ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS: {
    const { registryId, name, tags } = payload[ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS];
    const copyState = state[ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS]?.[registryId] || {};
    if (tags === null) {
      delete copyState[name];
    }
    return {
      ...state,
      [ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS]: {
        ...state[ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS],
        [registryId]: {
          ...(copyState),
          ...(tags === null ? {} : { [name]: tags }),
        },
      },
    };
  }

  default: {
    return state;
  }
  }
};
